<template>
  <div>
    <!-- 海報彈窗 -->
    <transition name="poster-fade">
      <div v-if="visible" class="poster-mask">
        <div class="poster-wrapper" @click.stop>

          <!-- Loading -->
          <div v-if="loading" class="poster-loading">
            <div class="loading-spinner"></div>
          </div>

          <!-- 海報圖片 -->
          <img
            v-show="!loading"
            class="poster-image"
            :src="posterUrl"
            alt="poster"
            @load="handleLoaded"
            @error="handleError"
          />

          <!-- 關閉按鈕 -->
          <div class="poster-close" @click="closePoster">
            ✕
          </div>

        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'PosterDialog',

  props: {
    // 後端返回的 show_poster
    showPoster: {
      type: [String, Number],
      default: '0'
    },

    // 海報圖片地址
    posterUrl: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      visible: false,
      loading: true
    }
  },

  mounted() {
    // show_poster == '1' 時自動顯示
    if (String(this.showPoster) === '1') {
      this.visible = true
      this.loading = true
    }
  },

  methods: {
    closePoster() {
      this.visible = false
    },

    handleLoaded() {
      this.loading = false
    },

    handleError() {
      this.loading = false
      console.error('海報加載失敗')
    }
  }
}
</script>

<style scoped>
.poster-mask {
  position: fixed;
  inset: 0;
  z-index: 9999;

  background: rgba(0, 0, 0, 0.75);

  display: flex;
  align-items: center;
  justify-content: center;

  padding: 20px;
  box-sizing: border-box;
}

.poster-wrapper {
  position: relative;

  width: 90vw;
  max-width: 1200px;

  min-height: 200px;

  display: flex;
  justify-content: center;
  align-items: center;
}

/* 海報圖片 */
.poster-image {
  width: 100%;
  height: auto;

  display: block;

  border-radius: 12px;

  object-fit: contain;

  max-height: 90vh;

  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.35);
}

/* loading */
.poster-loading {
  width: 120px;
  height: 120px;

  display: flex;
  align-items: center;
  justify-content: center;
}

.loading-spinner {
  width: 48px;
  height: 48px;

  border: 4px solid rgba(255, 255, 255, 0.3);
  border-top-color: #ffffff;

  border-radius: 50%;

  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* 關閉按鈕 */
.poster-close {
  position: absolute;
  top: -16px;
  right: -16px;

  width: 36px;
  height: 36px;

  border-radius: 50%;

  background: #fff;
  color: #333;

  display: flex;
  align-items: center;
  justify-content: center;

  cursor: pointer;

  font-size: 18px;
  font-weight: bold;
}

.poster-fade-enter-active,
.poster-fade-leave-active {
  transition: all 0.25s;
}

.poster-fade-enter,
.poster-fade-leave-to {
  opacity: 0;
}
</style>